import CtrlGroupDirective from './CtrlGroupDirective';

export default function () {
    var controlGroupDirectiveObj = new CtrlGroupDirective();
    var origLink = controlGroupDirectiveObj.link;
    controlGroupDirectiveObj.link = function (scope) {
        origLink.apply(this, arguments);
        scope.inline = true;
    };

    return controlGroupDirectiveObj;
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/basicinputs/InlineCtrlGroupDirective.js
// module id = 765
// module chunks = 0